import { useState } from 'react';

/**
 * The license-scan bearer token, read once from `location.hash` — identical shape and reasoning to
 * `useKioskToken.ts`, restated here rather than shared (this file is exactly as small as that one).
 * Staff hands the tablet over with the link already loaded, `LicenseScanTokenPanel.tsx`'s own
 * `/kiosk/license-scan#token=...` link — a fragment, never a query string, for the identical reason
 * `sessionTokens.ts`'s own header gives against ever putting a bearer credential somewhere a server
 * ever sees it.
 */
const TOKEN_PATTERN = /(?:^|&)token=([^&]+)/;

function readTokenFromHash(): string | null {
  const raw = window.location.hash;
  const hash = raw.startsWith('#') ? raw.slice(1) : raw;
  const match = TOKEN_PATTERN.exec(hash);
  if (match?.[1] === undefined) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    // A malformed percent-encoding in the fragment — treat exactly like "no token", the same
    // fail-closed shape `requireLicenseScanToken` on the server gives a malformed `Authorization`
    // header.
    return null;
  }
}

export function useLicenseScanToken(): string | null {
  const [token] = useState(readTokenFromHash);
  return token;
}
